<template>
    <b-sidebar id="filter-product-sidebar" bg-variant="white" no-header right shadow backdrop>
      <template #default="{ hide }">
        <div class="container-wrapper">
          <section class="header">
            <div class="guides-info-title">Filtros</div>
            <div class="actions">
              <Close class="close" @click="hide" />
            </div>
          </section>
  
          <section class="guides-summary-items">
            <b-form-group>
              <label for="query">Nome do Produto</label>
              <div class="search-container">
                <Search class="icon-search" />
                <b-form-input
                  id="name"
                  v-model="filters.name"
                  debounce="500"
                  placeholder="Nome do produto"
                />
              </div>
            </b-form-group>
            
            <b-form-group>
              <label for="period">
                Período
              </label>
              <div class="multiselect-container">
                <Periods
                  @select="handlePeriod"
                  ref="periodsRef"
                />
              </div>
            </b-form-group>            

            <b-form-group>
              <label for="product_class_id">
                Fornecedor
              </label>
              <multiselect
                class="with-border"
                id="provider"
                v-model="selectedProvider"
                track-by="id"
                label="name"
                placeholder="Selecionar"
                :options="providers"
                :searchable="true"
                :allow-empty="true"
                :option-height="40"
                :internal-search="false"
                :showLabels="false"
                @search-change="getProviders"
                @input="changeSelectedProvider"
                >
                  <template slot="caret">
                    <div class="chevron">
                      <v-chevron-down />
                    </div>
                  </template>
                  <template slot="noOptions"> Nenhuma opção </template>
                  <template slot="noResult"> Nenhum resultado </template>
                </multiselect>
            </b-form-group>

            <b-form-group>
              <label for="product_class_id">
                Tipo de Entrada
              </label>
              <multiselect
                id="stock_entry_type"
                autocomplete="off"
                ref="stock_entry_type"
                v-model="selectedStockEntryType"
                :options="stockTypes"
                track-by="value"
                label="label"
                :option-height="40"
                :showLabels="false"
                :searchable="true"
                placeholder="Selecionar"
                class="with-border"
                @select="el => ( filters.stock_entry_type = el.value )"
              >
                <template slot="caret">
                  <div class="chevron">
                    <v-chevron-down />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <label for="status">
                Status
              </label>
              <multiselect
                id="status"
                autocomplete="off"
                ref="status"
                v-model="filters.status"
                :options="['Pendente', 'Finalizada']"
                :option-height="40"
                :showLabels="false"
                :searchable="true"
                placeholder="Selecionar"
                class="with-border"
              >
                <template slot="caret">
                  <div class="chevron">
                    <v-chevron-down />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <label for="protocol">
                Cadeia Fria
              </label>
              <multiselect
                id="cold_chain_medicine"
                v-model="selectColdChainMedicine"
                :options="booleanChoices"
                track-by="value"
                label="label"
                class="with-border"
                :show-labels="false"
                placeholder="Selecionar"
                @select="el => ( filters.cold_chain_medicine = el.value )"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>

            <b-form-group v-if="userHasPermission('EstMedPsi1')">
              <label for="psychotropic_medication">
                Psicotrópico
              </label>
              <multiselect
                id="psychotropic_medication"
                v-model="selectedPsychotropicMedication"
                :options="booleanChoices"
                class="with-border"
                :show-labels="false"
                placeholder="Selecionar"
                track-by="value"
                label="label"
                @select="el => ( filters.psychotropic_medication = el.value )"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>
  
          </section>
  
          <div class="wrapper-button">
            <b-button block variant="primary" @click="saveChanges">
              Confirmar
            </b-button>
  
            <b-button
              @click="resetForm"
              variant="outline-primary"
            >
              Redefinir
            </b-button>
  
          </div>
        </div>
      </template>
    </b-sidebar>
  </template>
  
  <script>

  import { getCurrentClinic, userHasPermission } from '@/utils/localStorageManager'
  
  export default {
    components: {
      Close: () => import('@/assets/icons/close.svg'),
      Search: () => import('@/assets/icons/search.svg'),
      ChevronDown: () => import('@/assets/icons/chevron-down.svg'),
      Periods: () => import('@/components/General/Periods'),
      'v-chevron-down': () => import('@/assets/icons/chevron-down.svg'),
    },
    props: {
      query: {
        type: String,
        default: null
      }
    },
    mounted() {
        this.api.getMeasureUnits()
        .then(res => {
            this.measureUnits = res.data.map(el => ({ ...el, label: `${el.short_name} - ${el.name}` }));
        });

        this.api.getWarehouseProductCategories(this.clinic.id)
        .then(res => {
            this.categories = res.data;
        });

        this.api.getWarehouseProductClasses(this.clinic.id)
        .then(res => {
            this.classes = res.data;
        });

        this.getProviders('');
    },
    data() {
      return {
        clinic: getCurrentClinic(),
        summary: {},
        measureUnits: [],
        filters: {
          period: {
            type: 'create',
            'start': null,
            'end': null
          },
          name: null,
          psychotropic_medication: null,
          cold_chain_medicine: null,
          provider_id: null,
          stock_entry_type: null,
          status: null
        },
        booleanChoices: [
            { label: 'Sim', value : 1 },
            { label: 'Não', value : 0 }
        ],
        minimumQuantityOptions: [
            { label: 'Selecionar', value: null }, 
            { label: 'Abaixo do definido', value: -1 },
            { label: 'Acima do definido', value: 1 }
        ],
        selectedProvider: null,
        selectColdChainMedicine: null,
        selectedPsychotropicMedication: null,
        selectedStockEntryType: null,
        langDatePicker: {
          formatLocale: {
            weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
          }
        },
        providers: [],
        stockTypes : [
          { label: 'Abastecimento', value: 'SUPPLY' },
          { label: 'Ajustes no estoque', value: 'STOCK_ADJUSTMENTS' },
          { label: 'Cortesia (Amostra Grátis)', value: 'COURTESY' },
          { label: 'Doação', value: 'DONATION' },
          { label: 'Devolução', value: 'RETURN' },
          { label: 'Empréstimo', value: 'LOAN' },
          { label: 'Montagem de Kit', value: 'KIT_BUILD_MOVEMENT' },
          { label: 'Movimentação', value: 'TRANSACTION' },
        ],
      }
    },
    methods: {
      userHasPermission,
      handlePeriod(value) {
        this.filters.period.type = 'create';
        this.filters.period.start = value.start;
        this.filters.period.end = value.end;
      },
      async saveChanges() {
        const isLoading = this.$loading.show()
        const filters = this.filters;

        if(!filters.period?.start || !filters.period?.end) delete filters.period
        
        try {
          this.$emit('change', filters);  
          this.$emit('updateFilterApplied');  
          this.$root.$emit('bv::toggle::collapse', 'filter-product-sidebar')      
        } catch (err) {
          this.$toast.error(err.message)
        } finally {
          isLoading.hide()
        }
      },
      async resetForm() {
        this.filters = {
          period: {
            type: 'create',
            'start': null,
            'end': null
          },
          name: null,
          psychotropic_medication: null,
          cold_chain_medicine: null,
          provider_id: null,
          stock_entry_type: null,
          status: null
        };
        
        this.selectColdChainMedicine = null;
        this.selectedPsychotropicMedication = null;
        this.selectedStockEntryType = null;
        this.selectedProvider = null;

        this.$refs.periodsRef.clearCustom();
  
        this.$emit('change', {});
        this.$emit('updateFilterApplied');  
        this.$root.$emit('bv::toggle::collapse', 'filter-product-sidebar')    
      },
      getProviders(query) {
        this.isLoading = true
        this.api.getProviders(this.clinic.id, 1, query)
        .then(res => {
            this.providers = res.data.data
        })
        .catch(err => {
            this.$toast.error(err.message)
        });
       },
       changeSelectedProvider(value) {
        this.filters.provider_id = value ? value.id : null;
       }
    },
    watch: {
      filters: {
        handler(newValue) {
          
        },
        deep: true
      },
      query: {
        handler(newValeu) {
          this.filters.name = newValeu;
        },
        immediate: true
      }
    }
  }
  </script>
  
  <style lang="scss">
  .search-container {
    display: flex;
    flex-direction: row;
    position: relative;
  
    .icon-search {
      position: absolute;
      width: 24px;
      height: 24px;
      stroke: var(--neutral-500);
      margin: 7px 8px;
    }
  
    input {
      padding-left: 40px !important;
    }
  
  }
  
  #filter-product-sidebar {
    min-width: 450px;
  
    .title {
      display: flex;
      flex-direction: row;
  
      h4 {
        color: var(--dark-blue);
        font-weight: 700;
        font-size: 18px;
        margin-right: 20px;
      }
  
      h5 {
        color: var(--blue-600);
        font-weight: 600;
        font-size: 18px;
  
        span {
          color: var(--neutral-500);
        }
      }
    }
  
    .guides-summary {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 5px;
      padding: 20px;
      border-radius: 8px;
      border: 1px dashed var(--neutral-300);
      background: var(--neutral-100);
  
      .guides-summary-row {
        display: grid;
        grid-template-columns: auto 1fr auto 3fr;
        gap: 10px;
      }
  
      dt {
        color: var(--neutral-700);
      }
  
      dd {
        margin: 0;
      }
    }
  
    .guides-container {
      display: flex;
      flex-direction: column;
      width: 100%;
  
      .guide-container {
        margin: 10px 0;
      }
    }
  
    .container-wrapper {
      padding: 0 1rem;
    }
  
    .header {
      display: flex;
      width: 100%;
      padding: 1rem 0;
      justify-content: space-between;
      align-items: center;
    }
  
    .guides-info-title {
      font-family: 'Red Hat Display';
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      color: var(--dark-blue);
    }
  
    .actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
    }
  
    .optional {
      font-size: 14px;
      color: var(--type-placeholder);
    }
  
    .close {
      width: 25px;
      fill: var(--neutral-500);
    }
  
    .wrapper-button {
      width: 100%;
      display: flex;
      margin: 20px 0 !important;
      flex-direction: column;
  
      button {
        font-family: 'Nunito Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
  
      .btn-primary {
        color: var(--neutral-000);
      }
  
      .btn-outline-primary {
        margin-top: 10px;
        color: var(--blue-500);
      }
  
      .dropdown-item {
        font-weight: 400;
      }
    }
  }
  </style>